import * as THREE from 'three'
import Producer from '../Producer.js'

/**
 * WebGL 渲染器封裝
 * 負責 Canvas 渲染、管線 Compile 與顏色空間管理
 */
export default class Renderer {
    constructor() {
        this.producer = new Producer()
        this.canvas = this.producer.canvas
        this.scene = this.producer.scene
        this.camera = this.producer.camera
        this.sizes = this.producer.sizes

        this.init()
    }

    init() {
        this.instance = new THREE.WebGLRenderer({
            canvas: this.canvas,
            antialias: true,
            alpha: true,
            powerPreference: 'high-performance' // 優先指定高效能 GPU
        })

        // 顏色空間：若 Shader/Material 使用標準 sRGB 貼圖，設定為 SRGBColorSpace 以獲得正確的 Color Mapping
        this.instance.outputColorSpace = THREE.SRGBColorSpace

        this.instance.setSize(this.sizes.width, this.sizes.height)
        this.instance.setPixelRatio(this.sizes.pixelRatio)
    }

    /** 預先編譯 Shaders，避免第一次畫面上場時引發編譯卡頓 */
    compile() {
        if (this.scene && this.camera?.instance) {
            this.instance.compile(this.scene, this.camera.instance)
        }
    }

    /** 響應式更新渲染視窗與 Pixel Ratio */
    resize() {
        this.instance.setSize(this.sizes.width, this.sizes.height)
        this.instance.setPixelRatio(this.sizes.pixelRatio)
    }

    /** 執行每幀畫布渲染 */
    update() {
        this.instance.render(this.scene, this.camera.instance)
    }

    /** 完全釋放 WebGL 渲染器與 Context */
    destroy() {
        this.instance.dispose()
        this.instance.forceContextLoss()
    }
}
